enum SelectLoadEntryPoint {
  LoadBoard = 'loadboard',
  Reloads = 'reloads',
}

export default SelectLoadEntryPoint;
